/**
 * Navegação a partir de lançamentos listados em relatórios financeiros (DFC/DRE).
 */

export function getFinancialTransactionNavigation(transaction) {
  if (!transaction) return null;

  if (transaction.reconciledType === 'account_payable' && transaction.reconciledId) {
    return {
      path: '/erp/financeiro/contas-pagar',
      state: { search: String(transaction.reconciledId) }
    };
  }

  if (transaction.reconciledType === 'account_receivable' && transaction.reconciledId) {
    return {
      path: '/erp/financeiro/contas-receber',
      state: { search: String(transaction.reconciledId) }
    };
  }

  if (transaction.source === 'account_payable' && transaction.id) {
    return {
      path: '/erp/financeiro/contas-pagar',
      state: { search: String(transaction.id) }
    };
  }

  if (transaction.financialAccountId) {
    return {
      path: '/erp/financeiro/extrato-caixa',
      state: {
        financialAccountId: transaction.financialAccountId,
        highlightTransaction: {
          id: transaction.id,
          source: transaction.source || 'bank_statement'
        }
      }
    };
  }

  return null;
}

/** @deprecated Use getFinancialTransactionNavigation */
export const getDfcTransactionNavigation = getFinancialTransactionNavigation;

export function buildFinancialTransactionUrl(navigation) {
  if (!navigation?.path) return null;

  const url = new URL(navigation.path, window.location.origin);

  if (navigation.state?.search) {
    url.searchParams.set('search', String(navigation.state.search));
  }

  if (navigation.state?.financialAccountId) {
    url.searchParams.set('accountId', String(navigation.state.financialAccountId));
  }

  const highlight = navigation.state?.highlightTransaction;
  if (highlight?.id) {
    url.searchParams.set('highlightId', String(highlight.id));
    url.searchParams.set('highlightSource', highlight.source || 'bank_statement');
  }

  return `${url.pathname}${url.search}`;
}

export function openFinancialTransactionInNewWindow(transaction) {
  const navigation = getFinancialTransactionNavigation(transaction);
  if (!navigation) return;

  const url = buildFinancialTransactionUrl(navigation);
  if (!url) return;

  window.open(url, '_blank', 'noopener,noreferrer');
}
